import {Injectable} from "@angular/core";
import {Dialog, DialogRef} from '@angular/cdk/dialog';
import {GlobalPositionStrategy} from "@angular/cdk/overlay";
import {
    DownloadAppModalComponent,
    DownloadAppModalComponentData
} from "@app/presentation/services/download-app-modal/download-app-modal.component";
import {EnvironmentPlatform} from "src/environments/environment-template";
import {Platform} from "@angular/cdk/platform";


@Injectable({
  providedIn: 'root'
})
export class DownloadAppModalOpenerService {

  private dialogRef?: DialogRef<unknown, DownloadAppModalComponent> | null = null;
  constructor(
      private dialogService: Dialog,
      private platform: Platform
  ) {}

  open() {
    if (this.dialogRef != null) {
        this.dialogRef.close();
        return;
    }
    const platform = this.getPlatform();
    if (platform == null) {
        return;
    }
    this.dialogRef = this.dialogService.open<unknown, DownloadAppModalComponentData, DownloadAppModalComponent>(DownloadAppModalComponent,{
        maxHeight: '100vh',
        positionStrategy: new GlobalPositionStrategy().bottom('0px').centerHorizontally(),
        disableClose: true,
        panelClass: 'ep-download-app-modal',
        data: {
            platform: platform,
        }
    });
  }

  private getPlatform(): EnvironmentPlatform | null {
    if (this.platform.ANDROID) {
      return EnvironmentPlatform.AND;
    }
    if (this.platform.IOS) {
      return EnvironmentPlatform.IOS;
    }
    return null;
  }

}